import { useCallback } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { orderRoute } from 'modules/order/routes'
import { AuthInitRequest } from 'schema'

import { useLazyAuthInitQuery } from '../api'
import LoginForm from '../components/LoginForm/LoginForm'
import { authRoute } from '../routes'

export const LoginPage = () => {
  const [authInit, { isLoading }] = useLazyAuthInitQuery()
  const navigate = useNavigate()
  const { redirectTo } = authRoute.useSearch()

  const handleSuccess = useCallback(
    (widgetUrl: string) => {
      if (widgetUrl) {
        window.location.replace(widgetUrl)

        return
      }

      if (redirectTo === '/' || !redirectTo) {
        navigate(orderRoute)

        return
      }
      navigate({ to: redirectTo, replace: true })
    },
    [navigate, redirectTo]
  )

  const onSubmit = (payload: AuthInitRequest) => authInit(payload).unwrap().then(handleSuccess)

  return <LoginForm isLoading={isLoading} onSubmit={onSubmit} />
}
